import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule, LoaderModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { PopupModule } from '@progress/kendo-angular-popup';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { UploadsModule } from "@progress/kendo-angular-upload";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
@NgModule({
    exports: [
        IconsModule,
        NavigationModule,
        ButtonsModule,
        PopupModule,
        DialogsModule,
        ProgressBarModule,
        GridModule,
        ExcelModule,
        DropDownsModule,
        ButtonsModule ,
        LayoutModule ,
        LabelModule,
        InputsModule,
        DateInputsModule,
        PDFExportModule,
        UploadsModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule,
        LoaderModule,
        IndicatorsModule,
        NotificationModule,
        ChartsModule,
        ContextMenuModule,
        ExcelExportModule
    ]
})
export class KendoModule { }
